import { render, staticRenderFns } from "./SolicitacaoRegistro.vue?vue&type=template&id=2fbb12f9"
import script from "./SolicitacaoRegistro.vue?vue&type=script&lang=js"
export * from "./SolicitacaoRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports